import { render, staticRenderFns } from "./EmergencyContactComponent.vue?vue&type=template&id=0f58e592&scoped=true"
import script from "./EmergencyContactComponent.vue?vue&type=script&lang=js"
export * from "./EmergencyContactComponent.vue?vue&type=script&lang=js"
import style0 from "./EmergencyContactComponent.vue?vue&type=style&index=0&id=0f58e592&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f58e592",
  null
  
)

export default component.exports